import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { ServerPath } from '../../Constant/index.jsx';
import { _axios } from '../../utils/axios';
import Swal from 'sweetalert2';
import UpdatePurple from '../../assets/images/svg/UpdatePurple.svg';
import UpdateBlue from '../../assets/images/svg/UpdateBlue.svg';
import CalendarEdit from '../../assets/images/svg/calendar_edit.svg';
import { formatToIndianTime } from '../../utils/timeUtils.jsx';

const EditSos = (props) => {
    const [show, setShow] = useState(false);
    const [sosId, setSosId] = useState(props?.data?.sos_id);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [age, setAge] = useState('');
    const [requestType, setRequestType] = useState('');
    const [status, setStatus] = useState('');
    const [comment, setComment] = useState('');
    const [updating, setUpdating] = useState(false);
    const [originalMedicalEmg, setOriginalMedicalEmg] = useState(null);
    const [originalSecurityEmg, setOriginalSecurityEmg] = useState(null);
    const [dateTime, setDateTime] = useState('');

    // const formatDateTime = (dateString) => {
    //     if (!dateString) return '';
        
    //     // Create a date object in UTC
    //     const date = new Date(dateString);
        
    //     // Format the date in the local timezone
    //     const formattedDate = date.toLocaleDateString('en-US', {
    //         year: 'numeric',
    //         month: 'numeric',
    //         day: 'numeric',
    //         hour: '2-digit',
    //         minute: '2-digit',
    //         // second: '2-digit',
    //         hour12: true,
    //         timeZone: 'Asia/Kolkata' // Explicitly set to Indian timezone
    //     });
    
    //     return formattedDate.replace(',', ' -');
    // };

    useEffect(() => {
        if (props.data) {
            // ... other state updates ...
            setDateTime(formatToIndianTime(props.data.created_at));
            // ... rest of the useEffect ...
        }
    }, [props.data]);

    const calculateAge = (dob) => {
        if (!dob) return 'Not Specified';
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age.toString();
    };

    useEffect(() => {
        console.log('Received props data:', props.data);
        if (props.data) {
            setFirstName(props.data.user_name || '');
            setLastName(props.data.last_name || '');
            setAge(calculateAge(props.data.dateofbirth));
            // setDateTime(props.data.created_at.replace(',', ' -'));
            const getIndianTime = (utcTime) => {
                const date = new Date(utcTime);
                // Add IST offset
                const istTime = new Date(date.getTime() + (330 * 60000)); // 330 minutes = 5:30 hours in milliseconds
                
                const months = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                const hours = istTime.getHours();
                const minutes = istTime.getMinutes();
                const ampm = hours >= 12 ? 'PM' : 'AM';
                
                return `${months[istTime.getMonth()]}/${istTime.getDate()}/${istTime.getFullYear()} - ${hours % 12 || 12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
            };
            
            setDateTime(getIndianTime(props.data.created_at));  
            // setDateTime(formatDateTime(props.data.created_at));
            
          // Change this line to use the correct property name from the API response
        setRequestType(props.data.emergency_type || '');
           
            // Store original emergency values
            setOriginalMedicalEmg(props.data.medical_emg);
            setOriginalSecurityEmg(props.data.security_emg);
            
            // Set initial status based on the status value
            const getStatusText = (statusValue) => {
                const validStatuses = [
                    'Active',
                    'Pending',
                    'Dispatched',
                    'Cancelled',
                    'Closed & Delegated',
                    'Closed'
                ];
                
                return validStatuses.includes(statusValue) ? statusValue : 'Active';
            };
            
            const initialStatus = getStatusText(props.data.status);
            console.log('Setting initial status:', initialStatus);
            setStatus(initialStatus);
            
            setComment(props.data.comment || '');
        }
    }, [props.data]);

    const handleClose = () => setShow(false);
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log('Submitting with status:', status);

        if (!status) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Status is required',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        setUpdating(true);
        try {
            // Determine emergency values based on status
            let medical_emg = originalMedicalEmg;
            let security_emg = originalSecurityEmg;

            // If status is Cancelled, Closed & Delegated, or Closed, set both to 0
            if (['Cancelled', 'Closed & Delegated', 'Closed'].includes(status)) {
                medical_emg = 0;
                security_emg = 0;
            }

            const updatedSos = {
                status: status,
                medical_emg: medical_emg,
                security_emg: security_emg,
                comment: comment.trim()
            };

            console.log('Sending update request:', updatedSos);

            const response = await _axios.patch(`${ServerPath}/sos/admin/${sosId}`, updatedSos);

            if (response.data.success === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Record updated successfully',
                    confirmButtonColor: '#3085d6',
                }).then(() => {
                    handleClose();
                    if (props.onUpdate) {
                        props.onUpdate();
                    } else {
                        window.location.reload();
                    }
                });
            }
        } catch (error) {
            console.error('Error updating SOS:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'An error occurred while updating the SOS record',
                confirmButtonColor: '#3085d6',
            });
        } finally {
            setUpdating(false);
        }
    };

    return (
        <>
            <button
                className="btn-icon-only bg-transparent border-0 p-0"
                onClick={handleShow}
                onMouseEnter={(e) => {
                    e.currentTarget.querySelector('img').src = UpdateBlue;
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.querySelector('img').src = UpdatePurple;
                }}
            >
                <img
                    src={UpdatePurple}
                    alt="Update"
                    style={{ width: '24px', height: '24px' }}
                />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton className="bg-white border-bottom" style={{ paddingLeft: '24px' }}>
                    <Modal.Title style={{ color: '#000' }}>Update Report</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4">
                    <Form id='EditSosForm' onSubmit={handleSubmit}>
                        <Row>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridFirstName">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={firstName}
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridLastName">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={lastName}
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridAge">
                                    <Form.Label>Age</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={age}
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridDateTime">
                                    <Form.Label>Date & Time</Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            value={dateTime}
                                            readOnly
                                            disabled
                                            className="bg-light"
                                            style={{ paddingRight: '40px' }}
                                        />
                                        <img
                                            src={CalendarEdit}
                                            alt="calendar"
                                            style={{
                                                position: 'absolute',
                                                right: '12px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '20px',
                                                height: '20px',
                                                pointerEvents: 'none'
                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridRequestType">
                                    <Form.Label>Request Type</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={requestType}
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridStatus">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                        required
                                        style={{
                                            color: 'black'
                                        }}
                                    >
                                        <option value="Active">Active</option>
                                        <option value="Pending">Pending Admin Action</option>
                                        <option value="Dispatched">Dispatched</option>
                                        <option value="Cancelled">Cancelled - False Alarm</option>
                                        <option value="Closed & Delegated">Closed & Delegated</option>
                                        <option value="Closed">Closed</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formGridComment">
                                    <Form.Label>Comment</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        placeholder="Enter comment"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top">
                    <Button
                        variant="secondary"
                        onClick={handleClose}
                        style={{
                            backgroundColor: '#f8b84e',
                            border: 'none',
                            padding: '8px 24px'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        form='EditSosForm'
                        variant="primary"
                        type='submit'
                        disabled={updating}
                        style={{
                            backgroundColor: '#4318FF',
                            border: 'none',
                            padding: '8px 24px'
                        }}
                    >
                        {updating ? 'Updating...' : 'Update'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditSos;